<fa-layers [fixedWidth]="true">
   <fa-icon [icon]="primaryIcon" size="lg"></fa-icon>
   <fa-stack *ngIf="secondaryIcon !== null" class="sub-icon">
      <fa-icon [icon]="secondaryIcon" stackItemSize="lg"></fa-icon>
   </fa-stack>
</fa-layers>
